import { render, staticRenderFns } from "./ContainerBottomNav.vue?vue&type=template&id=8cb70a8c&"
import script from "./ContainerBottomNav.vue?vue&type=script&lang=js&"
export * from "./ContainerBottomNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports